<h2 mat-dialog-title>Confirmação de Exclusão</h2>
<mat-dialog-content>
  <p>Tem certeza de que deseja excluir este item?</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Cancelar</button>
  <button mat-button color="warn" (click)="onYesClick()">Excluir</button>
</mat-dialog-actions>
